import Vue from "vue";

import App from "@/app";
import router from "@/router";
import store from "@/store";

import APIService from "@/services/api";
import { AlertPlugin } from "./plugins/global-alert";

import "@/plugins/apexcharts";
import "@/plugins/bootstrap-vue";
import "@/plugins/inline-svg";
import "@/plugins/metronic";
import "@/plugins/permissions";
import { CurrencyFormatterPlugin } from "@/plugins/currency-formatter.js";
import { DateFormatterPlugin } from "@/plugins/date-formatter.js";
import { responsivnessPlugin } from "./plugins/responsiveness";
import { Settings } from "luxon";
import VueApexCharts from "vue-apexcharts";
import VCalender from "v-calendar";
import "@/lib/rules";

Vue.component("apex-chart", VueApexCharts);

Vue.use(DateFormatterPlugin);
Vue.use(CurrencyFormatterPlugin);
Vue.use(responsivnessPlugin);
Vue.use(VueApexCharts);
Vue.use(VCalender);
Vue.use(AlertPlugin, { store });


Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

new APIService();

Settings.defaultZone = "Asia/Dubai";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
